module.exports = __webpack_public_path__ + "static/media/wps3.png.0fc82aa6.jpg";